import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { StockListService } from '../..//services/stock-list.service';
import { TitleService } from '../../services/title.service';
import { Product } from '../../model/product';
import { Observable, Subscription } from 'rxjs';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { EditStockItemComponent } from '../edit-stock-item/edit-stock-item.component';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-manage-stock-item',
    templateUrl: './manage-stock-item.component.html',
    styleUrls: ['./manage-stock-item.component.scss'],
    imports: [BreadCrumbComponent, FormsModule, EditStockItemComponent, AsyncPipe]
})
export class ManageStockItemComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private stockListService = inject(StockListService);
  private breadcrumbService = inject(BreadcrumbService);
  private titleService = inject(TitleService);


  product$: Observable<Product>;
  safeImageUrl: string;

  subscription: Subscription;
  productSubscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.route.params.subscribe(routeParams => {
      this.product$ = this.stockListService.fetchStockItemByCode(routeParams.code);
      this.productSubscription = this.product$.subscribe(product => {
        this.titleService.set(`Edit Stock Item: ${product.code}`);
        this.breadcrumbService.setGallery(product.collection, product.type);
      }, () => {
        this.router.navigate(['/404']);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.productSubscription) {
      this.productSubscription.unsubscribe();
    }
  }
}
